import { useQuery } from '@tanstack/react-query'

import { apiClient } from '../../lib/client.js'

export interface AccessChallenge {
  challenge: string
  question: string
}

/**
 * Le petit calcul posé devant le mur du nom (ACCES-PERSO-DEFI).
 *
 * `staleTime: 0` et pas de cache : une question est faite pour être posée une
 * fois. Après un échec, le formulaire en redemande une — la précédente a pu
 * expirer, et reposer la même serait une invitation à la rejouer.
 */
export const useGetAccessChallengeQuery = () =>
  useQuery<AccessChallenge>({
    gcTime: 0,
    queryFn: async () => {
      const response = await apiClient.client.get<AccessChallenge>('/public/access-challenge')
      return response.data
    },
    queryKey: ['public', 'access-challenge'],
    staleTime: 0,
  })
